import { ignoreExpirationDate, refreshExpirationDate } from '../actions/publicActions';
import datapoints from '../datapoints';
import { SharingData } from '../schema/SharingData';
import { logUsage } from 'owa-analytics';
import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import strings from 'owa-strings/owa-mail-strings';

export function getExpirationCustomActions(sharingData: SharingData): InfoBarCustomAction[] | null {
    const refreshCustomAction: InfoBarCustomAction = {
        text: strings.SuggestActionRefreshTheLink,
        action: () => {
            refreshExpirationDate(sharingData.id);
            logUsage(datapoints.SharingTipsRefreshExpirationInfoBarClicked.datapoint.name);
        },
    };
    const ignoreCustomAction: InfoBarCustomAction = {
        text: strings.SuggestActionIgnoreExpiration,
        action: () => {
            ignoreExpirationDate(sharingData.id);
            logUsage(datapoints.SharingTipsIgnoreExpirationInfoBarClicked.datapoint.name);
        },
    };
    return [refreshCustomAction, ignoreCustomAction];
}
